import { LoadingCard, PrimaryHeading, UserAvatar } from "commonUI";
import { useUserDetails } from "hooks/user";
import { t } from "i18next";

export default function Greetings() {
  const { isLoading, data: userDetails } = useUserDetails();
  return (
    <div className="bg-white flex items-center gap-15 p-2 rounded-5">
      {isLoading ? (
        <>
          <LoadingCard />
        </>
      ) : (
        <>
          <UserAvatar
            user={userDetails}
            style={{ width: "48px", height: "48px" }}
          />
          <div>
            <PrimaryHeading className="leading-6">
              {t("dashboard.greeting.title", {
                name: userDetails?.name,
                time:
                  new Date().getHours() < 12
                    ? t("dashboard.greeting.morning")
                    : new Date().getHours() < 15
                    ? t("dashboard.greeting.afternoon")
                    : t("dashboard.greeting.evening"),
              })}
            </PrimaryHeading>
            <p className="body-text m-0">
              {t("dashboard.greeting.explainerText")}
            </p>
          </div>
        </>
      )}
    </div>
  );
}
